import { useEffect } from 'react';
var SEARCH_QUERY_KEY = 'query';
export var useSearchQuery = function (setInputValue) {
    useEffect(function () {
        var params = new URLSearchParams(location.search);
        var searchQuery = params.get(SEARCH_QUERY_KEY);
        if (searchQuery) {
            setInputValue(searchQuery);
        }
    }, []);
};
